import { Link } from "react-router-dom";
import { BrandMark } from "@/components/politics/brand";

const COLS = [
  {
    title: "RSM Politics",
    links: [
      { label: "Visão geral", href: "/politics" },
      { label: "Como funciona", href: "/politics#pilares" },
      { label: "Para agências", href: "/politics/agencies" },
      { label: "Diretório de parceiros", href: "/politics/parceiros" },
      { label: "Acesso do parceiro", href: "/admin/login" },
      { label: "FAQ", href: "/politics#faq" },
    ],
  },
  {
    title: "Plataforma",
    links: [
      { label: "Campanhas", href: "/campanhas" },
      { label: "SaaS", href: "/saas" },
      { label: "Agentes RSM", href: "/agentes" },
    ],
  },
  {
    title: "Empresa",
    links: [
      { label: "Sobre", href: "/sobre", placeholder: true },
      { label: "Contato", href: "/politics#contato" },
      { label: "Trabalhe conosco", href: "/carreiras", placeholder: true },
      { label: "Política de privacidade", href: "/privacidade" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1B1D1D] text-[#F5FAFB] pt-20 pb-10"
    >
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <BrandMark size={40} color="#208BFF" />
              <span className="font-display text-lg font-semibold tracking-tight">
                RSM <span style={{ color: "#208BFF" }}>Politics</span>
              </span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-[#F5FAFB]/60">
              Plataforma de mobilização, pesquisa e inteligência política nascida
              em Brasília. Construindo campanhas de alto impacto na eleição de
              2026.
            </p>
            <Link
              to="/politics#contato"
              data-testid="footer-cta"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#208BFF] px-6 py-3 text-sm font-semibold text-white transition-all duration-300 ease-out hover:bg-[#1B73D6] hover:-translate-y-0.5"
            >
              Quero minha base na RSM
            </Link>
          </div>

          <div className="md:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {COLS.map((col) => (
              <div key={col.title}>
                <span className="text-[11px] font-semibold tracking-[0.22em] uppercase text-[#7D8188]">
                  {col.title}
                </span>
                <ul className="mt-5 space-y-3">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      {l.placeholder ? (
                        <span
                          data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                          className="text-sm text-[#F5FAFB]/55 cursor-not-allowed inline-flex items-center gap-2"
                          title="Em breve"
                        >
                          {l.label}
                          <span className="text-[9px] tracking-wider uppercase text-[#7E20FF]/80">
                            em breve
                          </span>
                        </span>
                      ) : !l.placeholder && l.href.startsWith("/") &&
                        !l.href.includes("#") ? (
                        <Link
                          to={l.href}
                          data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                          className="text-sm text-[#F5FAFB]/75 hover:text-[#208BFF] transition-colors"
                        >
                          {l.label}
                        </Link>
                      ) : (
                        <a
                          href={l.href}
                          data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                          className="text-sm text-[#F5FAFB]/75 hover:text-[#208BFF] transition-colors"
                        >
                          {l.label}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 border-t border-white/8 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <span className="text-xs text-[#F5FAFB]/45">
            © {new Date().getFullYear()} RSM Politics. Todos os direitos
            reservados.
          </span>
          <span className="text-xs text-[#F5FAFB]/45">
            Brasília · Distrito Federal · Brasil
          </span>
        </div>
      </div>
    </footer>
  );
}
